import { Image, Hardware } from '../../../Cloud.model';

export function selectedHardwareDoesntSupportsSelectedImage(image: Image, hardware: Hardware): boolean {
    if (hardware.disk < image.minRequirements.disk) return true
    if (hardware.memory < image.minRequirements.memory) return true
    if (hardware.vcpu < image.minRequirements.vcpu) return true

    return false
}

export function getMemoryLabel(memory: number) {
    let result = memory / 1024;
    
    if (result < 1) return `${memory} MB`
    
    return `${Math.round(result)} GB`
}
